// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1faRE","right":"styles_right__V4Dso"};